import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m7 15 5 5 5-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m7 9 5-5 5 5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ChevronsUpDown";
const ChevronsUpDown = memo(themed(Icon));
export {
  ChevronsUpDown
};
//# sourceMappingURL=chevrons-up-down.js.map
